"use client"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  useTheme,
} from "@mui/material"
import LogoutIcon from "@mui/icons-material/Logout"
import WarningIcon from "@mui/icons-material/Warning"
import { useToast, TOAST_SEVERITY } from "../context/ToastContext"

const LogoutConfirmationModal = ({ open, onClose, onConfirm }) => {
  const theme = useTheme()
  const { showToast } = useToast()

  const handleConfirm = () => {
    onConfirm()
    showToast("You have been logged out successfully", TOAST_SEVERITY.SUCCESS)
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          background: "rgba(13, 15, 25, 0.95)",
          border: "1px solid rgba(0, 229, 255, 0.2)",
          borderRadius: 2,
          boxShadow: "0 0 20px rgba(0, 0, 0, 0.5)",
          overflow: "hidden",
          maxWidth: "450px",
          width: "100%",
        },
      }}
    >
      {/* Decorative header */}
      <Box
        sx={{
          height: "8px",
          background: "linear-gradient(90deg, #f44336 0%, rgba(244, 67, 54, 0.3) 50%, rgba(0, 0, 0, 0) 100%)",
          width: "100%",
        }}
      />

      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          pb: 1,
        }}
      >
        <WarningIcon sx={{ color: theme.palette.warning.main }} />
        <Typography variant="h6" component="span" sx={{ fontWeight: "bold" }}>
          Confirm Logout
        </Typography>
      </DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ color: "rgba(255, 255, 255, 0.8)", mb: 2 }}>
          Are you sure you want to log out of your account?
        </DialogContentText>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            p: 2,
            borderRadius: 1,
            bgcolor: "rgba(0, 0, 0, 0.3)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            mb: 2,
          }}
        >
          <LogoutIcon sx={{ color: theme.palette.error.main }} />
          <Typography
            variant="body1"
            component="span"
            sx={{
              fontWeight: "medium",
              color: theme.palette.error.main,
            }}
          >
            You will need to authenticate with Discord again to log back in.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderColor: "rgba(255, 255, 255, 0.3)",
            color: "rgba(255, 255, 255, 0.7)",
            "&:hover": {
              borderColor: "rgba(255, 255, 255, 0.5)",
              backgroundColor: "rgba(255, 255, 255, 0.05)",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          endIcon={<LogoutIcon />}
          sx={{
            "&:hover": {
              boxShadow: "0 0 15px rgba(244, 67, 54, 0.4)",
            },
          }}
        >
          Logout
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default LogoutConfirmationModal
